import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const salePointKeys = {
  all: ['salePoints'],
  lists: () => [...salePointKeys.all, 'list'],
};

/**
 * Hook para obtener todos los puntos de venta
 */
export const useSalePoints = () => {
  return useQuery({
    queryKey: salePointKeys.lists(),
    queryFn: async () => {
      const response = await apiClient.get('sale_points');
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
};